import LoginApi from 'api/LoginApi'
import PluginApi from 'api/PluginApi'
import { Notify } from 'quasar'

export default class AuthHelper {
    static getToken() {
        let context = jng.context.getContext()
        if (context) return context.data['token']
    }

    static getLanguageId() {
        let context = jng.context.getContext()
        if (context) return jng.coalesce(context.data['languageId'], 'en')
        return 'en'
    }

    static getWorkplaceId() {
        let context = jng.context.getContext()
        if (context) return jng.coalesceProp(context.data,['user','workplaceId'], '')
        return ''
    }

    static getCurrWorkplaceId(){
        let context = jng.context.getContext()
        if (context) return jng.coalesceProp(context.data,['workplaceId'], '')
        return ''
    }

    static workplaceRights(){
        let context = jng.context.getContext()
        if (context) return jng.coalesceProp(context.data,['user','workplaceRights'], '')
        return ''
    }

    static getWorkplaceName() {
        let context = jng.context.getContext()
        if (context) return jng.coalesceProp(context.data,['user','workplaceName'], '')
        return ''
    }

    static getUserId() {
        let context = jng.context.getContext()
        if (context) return jng.coalesceProp(context.data,['user','id'], '')
        return ''
    }

    static getUserType(){
      let context = jng.context.getContext()
      if (context) return jng.coalesceProp(context.data,['userType'], '')
      return ''
    }

    static getForShowMenu(){
      let context = jng.context.getContext()
      if (context) return jng.coalesceProp(context.data,['showMenu'], '')
      return ''
    }

    static getIsTeacher(){
      let context = jng.context.getContext()
      if (context) return jng.coalesceProp(context.data,['isTeacher'], false)
      return false
    }

    static getIsStudent(){
      let context = jng.context.getContext()
      if (context) return jng.coalesceProp(context.data,['isStudent'], false)
      return false
    }

    static getPortal(){
      let context = jng.context.getContext()
      if (context) return jng.coalesceProp(context.data,['portalFor'], '')
      return ''
    }

    static getSettingMenuSubject(){
      let context = jng.context.getContext()
      if(context) return jng.coalesceProp(context.data,['isSubjectMenu'], false)
    }

    static getPortalList(){
      let context = jng.context.getContext()
      if (context) return jng.coalesceProp(context.data,['portalList'], [])
      return []
    }

    static getUserName() {
        let context = jng.context.getContext()
        let userName = ""
        if (context) {
          // return jng.coalesceProp(context.data,['user','name'], '')
          if(context.data.user.name == ""){
            userName = jng.coalesceProp(context.data,['userName'], '')
            if(jng.coalesceProp(context.data,['userName'], '') == "admin") {
              return 'Admin'
            } else {
              return userName
            }
          } else {
            return jng.coalesceProp(context.data,['user','name'], '')
          }
        }
        return ''
    }

    static getEducationId() {
        let context = jng.context.getContext()
        if (context) return jng.coalesce(context.data['educationLevelId'], '')
        return ''
    }

    static getYearProgramId() {
        let context = jng.context.getContext()
        if (context) return jng.coalesce(context.data['yearProgramId'], '')
        return ''
    }

    static getCurrentSchoolGradeId() {
        let context = jng.context.getContext()
        if (context) return jng.coalesce(context.data['currentSchoolGradeId'], '')
        return ''
    }

    static setForCheckToken(context, data) {
        context.data['userName'] = data.userName
        jng.context.saveContext()
    }

    static hasLogin(context) {
        if (context.data['token'] && context.data['token'] != '' && context.data['userName'] && context.data['userName'] != '') {
          if (!context.data['loginTime']) {
            return false
          }
          let loginTime = new Date(context.data['loginTime'])
          let now = new Date()
          let diff = now - loginTime
          let diffMinutes = diff / (1000 * 60)
          if (diffMinutes > 1) {
            this.setUserContext(context)
          }
          
          return true
        }
        return false
    }
    static setUserContext(context) {
        return new Promise((resolve, reject) => {
            LoginApi.getUserContext()
                .then(AuthHelper.setSettingMenuSubject(context))
                .then((userContextData) => {
                    context.data['user'] = userContextData
                    context.data['languageId'] = userContextData.languageId
                    context.data['loginTime'] = new Date().toUTCString()
                    jng.context.saveContext()
                    resolve(context)
                })
                .catch(err => {
                  const status = err?.err?.response?.status
                  if (status === 504) {
                    Notify.create({
                      message: "Cannot connect to the server. Please check your internet connection or contact our support.",
                      color: 'negative',
                      timeout: 0,
                      actions: [{ label: 'Dismiss', color: 'white', handler: () => {} }]
                    })
                    reject(err)
                  } else {
                    if (!(window.location.href.endsWith('/#/') || window.location.href.includes("login"))) {
                      jng.context.removeContext()
                      window.location.href = '/'
                    }
                    reject(err)
                  }
                })
        })
    }

    static async setEducation(context, id, name, yearProgramId, currentSchoolGradeId) {
        context.data['educationLevelId'] = id
        context.data['educationLevelName'] = name
        context.data['yearProgramId'] = yearProgramId
        context.data['currentSchoolGradeId'] = currentSchoolGradeId
        jng.context.saveContext()
    }

    static async changeLanguage(context, languageId) {
        if (AuthHelper.hasLogin(context)) {
            await LoginApi.changeCurrentLanguage(languageId)
        }
        context.data['languageId'] = languageId
        jng.context.saveContext()
    }

    static async setSettingMenuSubject(context){
      await PluginApi.getByTenant(response => {
        let currPluginSubject = response.findFirst("SELECT_SUBJECT", 'feature')
        let isSubjectMenu = false
        if (jng.isDefined(currPluginSubject)){
            isSubjectMenu = currPluginSubject.isActive
        }
        context.data['isSubjectMenu'] = isSubjectMenu
        jng.context.saveContext()
      })
    }

    static async changeWorkplace(context, workplaceId){
        context.data['workplaceId'] = workplaceId
        jng.context.saveContext()
    }

    static async changePortal(context, portalFor){
        context.data['portalFor'] = portalFor
        if(context.data.portalList.length > 0){
          context.data.portalList.forEach(val => {
            if(val.portalFor == portalFor){
              val.isActive = true
            }
            else{
              val.isActive = false
            }
          })
        }

        if(context.data.portalFor == 'teacher'){
          context.data.isTeacher = true
        }
        else{
          context.data.isTeacher = false
        }

        if(context.data.portalFor == 'student'){
          context.data.isStudent = true
        }
        else{
          context.data.isStudent = false
        }
        
        
        jng.context.saveContext() 
    }

    static async setFromLoginForQuiz(context, loginInfo){
        context.data['token'] = loginInfo.token
        context.data['userName'] = loginInfo.userName
        context.data['userType'] = loginInfo.userType

        return AuthHelper.setUserContext(context)
    }

    static async setFromLogin(context, loginInfo) {
        context.data['token'] = loginInfo.token
        context.data['userName'] = loginInfo.userName
        context.data['userType'] = loginInfo.userType

        let isAdmin = false
        let isTeacher = false
        let isStudent = false
        let isAdminTenant = false
        let portalList = []
        let currPortal = ""
        loginInfo.userType.forEach(val => {
          if(val.userType == "ADM"){
            isAdmin = true
            portalList.push({
              portalFor:'admin',
              label:'Admin',
              isActive:false,
              orderNo:1
            })
          } else if (val.userType == "ADM_TENANT") {
            isAdminTenant = true
            portalList.push({
              portalFor:'admin',
              label:'Admin',
              isActive:false,
              orderNo:1
            })
          }
          
          if (val.userType == "TEACHER") {
            isTeacher = true
            portalList.push({
              portalFor:'teacher',
              label:'Teacher',
              isActive:false,
              orderNo:2
            })
          } 
          
          if (val.userType == "STUDENT") {
            isStudent = true
            portalList.push({
              portalFor:'student',
              label:'Student',
              isActive:false,
              orderNo:3
            })
          } 
        })

        if(loginInfo.userType.length > 0){
      
          let userTypeAdmin = loginInfo.userType.findFirst('ADM_TENANT', 'userType') || loginInfo.userType.findFirst('ADM', 'userType')
          let userTypeTeacher = loginInfo.userType.findFirst('TEACHER', 'userType')
          let userTypeStudent = loginInfo.userType.findFirst('STUDENT', 'userType')
          if(jng.isDefined(userTypeAdmin)){
            context.data['portalFor'] = currPortal = 'admin'
          }
          else if(jng.isDefined(userTypeTeacher)){
            context.data['portalFor'] = currPortal = 'teacher'
          }
          else if(jng.isDefined(userTypeStudent)){
            context.data['portalFor'] = currPortal = 'student'
          }
          
          // if(jng.isDefined(userTypeStudent)){
          //   context.data['isStudent'] = true
          // }

          portalList.forEach(item => {
            if(item.portalFor == currPortal){
              item.isActive = true
            }
          })

          context.data['portalList'] = portalList.orderBy(['orderNo']);
        }

        if(context.data['portalFor'] == 'teacher'){
          context.data['isTeacher'] = true
        }

        if(context.data['portalFor'] == 'student'){
          context.data['isStudent'] = true
        }


        return AuthHelper.setUserContext(context)
    }

    static async setUserContextIfNotExists(context) {
        if (AuthHelper.hasUserContext(context)) return jng.emptyPromise()
        return AuthHelper.setUserContext(context)
    }

    static hasUserContext(context) {
        if (context.data['user']) return true
        return false
    }

    static removeUserContext(context) {
        delete context.data['userName']
        delete context.data['user']
        delete context.data['token']
        jng.context.saveContext()
    }

    static getUrlAfterLogin() {
        return {name: 'home'}
    }

    static getUrlQuiz(param){
        return {name: 'Assessment Quiz', params: { quizIdBase64: param.quizIdBase64, quizNameBase64: param.quizNameBase64}}
    }

    static async login(userName, password, $router){
        let response = await LoginApi.login({userName: userName, password: password})
        let context = jng.context.getContext()
        AuthHelper.setFromLogin(context, response).then(() => {
            $router.push(AuthHelper.getUrlAfterLogin())
        })
    }

    static async loginUsingEmail(email, userName, param, $router){
        let response = await LoginApi.loginUsingEmail({id: email, name: userName})
        let context = jng.context.getContext()
        AuthHelper.setFromLoginForQuiz(context, response).then(() => {
            $router.push(AuthHelper.getUrlQuiz(param))
        })
    }
}
